/** Loads BuildConnect pro directory JSON (180 demo profiles). */
(function () {
  function ready() {
    document.dispatchEvent(new Event('bc-pros-ready'));
  }

  function load() {
    var url = window.BC_PROS_URL;
    if (!url) {
      ready();
      return;
    }
    fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        window.BC_PROS = data || [];
        ready();
      })
      .catch(function () {
        ready();
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', load);
  } else {
    load();
  }
})();
